export default {
      id: "hard-hat-usage",
      viewBox: "0 0 62 38",
      url: __webpack_public_path__ + "sprite.svg#hard-hat",
      toString: function () {
        return this.url;
      }
    }